import LegalLayout from '../LegalLayout';

export default function CookiesPolicy() {
  const openSettings = () => {
    window.dispatchEvent(new Event('resstro:open-cookie-settings'));
  };

  return (
    <LegalLayout title="Политика использования файлов cookies" updatedAt="24 апреля 2026 года">
      <p>
        Сайт <strong>resstro.ru</strong> использует файлы cookies и аналогичные технологии
        (localStorage, sessionStorage). Эта политика объясняет, какие данные собираются,
        с какой целью и как пользователь может управлять своим выбором.
      </p>

      <h2>1. Что такое cookies</h2>
      <p>
        Cookies это небольшие текстовые файлы, которые сайт сохраняет в&nbsp;браузере
        пользователя. Они нужны, чтобы запоминать настройки, поддерживать сессию входа
        и&nbsp;улучшать работу продукта.
      </p>

      <h2>2. Категории cookies, которые мы используем</h2>

      <h3>2.1. Технические (всегда активны)</h3>
      <p>
        Без этих файлов сайт работать не сможет. Мы не запрашиваем согласие на их
        использование, поскольку они необходимы для предоставления услуги.
      </p>
      <ul>
        <li>сессионный токен авторизации (httpOnly cookie);</li>
        <li>защита от подделки межсайтовых запросов (CSRF);</li>
        <li>запоминание выбора по cookies (resstro:cookie-consent).</li>
      </ul>

      <h3>2.2. Аналитические (только с&nbsp;согласия)</h3>
      <p>
        Помогают понять, какие страницы и&nbsp;функции используются, где возникают
        ошибки и&nbsp;замедления. Не используются для рекламы.
      </p>
      <ul>
        <li>агрегированная статистика посещений и&nbsp;конверсий;</li>
        <li>метрики времени загрузки страниц;</li>
        <li>обезличенные сессии пользователей.</li>
      </ul>
      <p>
        На&nbsp;момент публикации редакции аналитические сервисы на&nbsp;сайте не&nbsp;подключены,
        ни&nbsp;одно событие не&nbsp;передаётся. Перед их&nbsp;подключением мы&nbsp;обновим
        список выше и&nbsp;запросим согласие повторно.
      </p>

      <h3>2.3. Маркетинговые (только с&nbsp;согласия)</h3>
      <p>
        Используются для оценки эффективности рекламных кампаний и&nbsp;показа релевантных
        предложений на&nbsp;других сайтах.
      </p>
      <ul>
        <li>пиксели рекламных сетей (Я.Метрика, ВКонтакте, myTarget), после подключения;</li>
        <li>UTM-метки и&nbsp;параметры источников трафика.</li>
      </ul>

      <h2>3. Срок хранения</h2>
      <ul>
        <li>сессионные cookies удаляются при закрытии браузера;</li>
        <li>выбор пользователя по&nbsp;cookies хранится 12&nbsp;месяцев, после чего баннер показывается повторно;</li>
        <li>cookies аналитики и&nbsp;рекламы: в&nbsp;соответствии с&nbsp;настройками поставщика, обычно от&nbsp;90&nbsp;дней до&nbsp;24&nbsp;месяцев.</li>
      </ul>

      <h2>4. Как управлять cookies</h2>
      <p>
        Управлять выбором можно тремя способами:
      </p>
      <ul>
        <li>
          в&nbsp;баннере, который показывается при первом посещении сайта;
        </li>
        <li>
          в&nbsp;любой момент через кнопку{' '}
          <button type="button" onClick={openSettings} className="link">
            «Настроить cookies»
          </button>
          ;
        </li>
        <li>в&nbsp;настройках своего браузера, там можно очистить cookies или запретить их сохранение.</li>
      </ul>
      <p>
        Отключение технических cookies может сделать сайт неработоспособным:
        не получится войти в&nbsp;кабинет, сохранить настройки или совершить оплату.
      </p>

      <h2>5. Передача данных третьим лицам</h2>
      <p>
        Мы&nbsp;не&nbsp;продаём данные о&nbsp;посещениях сайта. Cookies аналитических
        и&nbsp;рекламных сервисов передаются их&nbsp;поставщикам только при включении
        соответствующей категории. Полный перечень обработчиков и&nbsp;стран обработки
        приведён в&nbsp;{' '}
        <a href="/legal/privacy">Политике конфиденциальности</a>.
      </p>

      <h2>6. Изменения политики</h2>
      <p>
        При существенных изменениях категорий cookies мы&nbsp;увеличиваем версию документа
        и&nbsp;запрашиваем согласие повторно.
      </p>

      <h2>7. Контакты</h2>
      <p>
        Вопросы по&nbsp;этой политике:{' '}
        <a href="mailto:resstrosaas@mail.ru">resstrosaas@mail.ru</a>.
      </p>
    </LegalLayout>
  );
}
